export default __webpack_public_path__ + "static/media/hero-default.32505739.jpg";